/*
 * @Editor: chenqy
 * @Description: 类似html标签中的title属性 弹出窗功能，但能自定义样式。
 *
 * ============== 使用方法 ===============
 * 1、默认样式(白色主题)： v-popover="你的内容"
 * 2、切换样式(黑色)： v-popover="{content:'你的内容', theme: 'dark'}"
 * 3、若需要特殊的样式请使用该方式： v-popover="{content:'你的内容', className: '你的样式'}"
 *
 * @Date: 2023-09-01 10:05:47
 * @LastEditors: Chenqy
 * @LastEditTime: 2023-09-06 16:08:04
 */

let moveFn = function (e) {
  e.stopPropagation();
  if (isHidden) {
    return;
  }
  createElement(e);
};
let leaveFn = function (e) {
  e.stopPropagation();
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  isHidden = false;
  document.querySelector(".ds-popover-content")?.remove();
};
let downFn = function (e) {
  e.stopPropagation();
  if (!isHidden) {
    isHidden = true;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    document.querySelector(".ds-popover-content")?.remove();
  }
};
let isHidden = false; // 关闭弹窗
let timer = null;
let cursorPosition = [];
/**
 * @description:
 * @param e: Event： 事件对象
 * @param text: String：展示的内容
 * @param customClass: String：自定义弹窗样式
 * @param theme: String：主题(light/dark)
 * @return
 */
function createElement(e) {
  cursorPosition = [e.pageX, e.pageY];
  if (!timer) {
    // 为了提高性能和防止误触发，延迟500ms执行tooltip弹窗
    timer = setTimeout(() => {
      let closestNode = e.target.vTitleDom || e.target; // 寻找设置过title的元素
      if (!closestNode.__vueDirectiveTitleOption__) {
        while (!closestNode.__vueDirectiveTitleOption__) {
          closestNode = e.target.parentElement;
        }
        e.target.vTitleDom = closestNode;
      }

      let {
        content,
        className,
        theme = "light",
      } = closestNode.__vueDirectiveTitleOption__;

      let node = document.createElement("div");
      node.innerText = content;
      // node.style.opacity = 0;
      let attrs = {
        class: className
          ? `${className} ds-popover-content ds-popover-content-${theme}`
          : `ds-popover-content ds-popover-content-${theme}`,
      };
      Object.keys(attrs).forEach((k) => {
        node.setAttribute(k, attrs[k]);
      });

      document.body.appendChild(node);
      const [pageX, pageY] = cursorPosition;
      // 箭头
      let arrow = document.createElement("div");

      // 计算位置
      const { width, height } = node.getBoundingClientRect();
      // 可视窗口尺寸
      const viewHeight = window.innerHeight;
      const viewWidth = window.innerWidth;
      // 上下方向判断
      if (viewHeight - pageY - height - 10 > 0) {
        // 下
        node.style.top = `${pageY + 20}px`;
        arrow.className =
          "ds-popover-content-arrow ds-popover-content-arrow__bottom";
      } else {
        // 上
        node.style.top = `${pageY - height - 20}px`;
        arrow.className =
          "ds-popover-content-arrow ds-popover-content-arrow__top";
      }
      // 左右方向判断(位置尽量居中)
      const cursorLeft = pageX; // 当前鼠标离可视区左边距离
      const cursorRight = viewWidth - pageX; // 当前鼠标离可视区左边距离
      const nodeHalfWidth = width / 2;
      let nodeLeft = 0;
      let arrowOffsetX = 0;
      const gap = 10; // 边缘部分间隙
      // 右方向优先
      if (cursorRight > width) {
        if (nodeHalfWidth < cursorLeft) {
          nodeLeft = pageX - nodeHalfWidth;
          arrowOffsetX = "50%";
        } else {
          nodeLeft = pageX - cursorLeft + gap;
          arrowOffsetX = `${cursorLeft}px`;
        }
      } else {
        if (nodeHalfWidth < cursorRight) {
          nodeLeft = pageX - nodeHalfWidth;
          arrowOffsetX = "50%";
        } else {
          nodeLeft = pageX - width + cursorRight - gap;
          arrowOffsetX = `calc(100% - ${cursorRight}px)`;
        }
      }
      node.style.left = `${nodeLeft}px`;
      arrow.style.left = arrowOffsetX;
      node.appendChild(arrow);
    }, 500);
  }
}
// 标准化数据
function handleDataFormatter(data) {
  let content = dsf.isObject(data) ? data?.content || "" : data + "";
  let className = data?.className;
  let theme = data?.theme;
  return {
    content,
    className,
    theme,
  };
}
export default {
  bind: function (el, { value }) {
    let data = handleDataFormatter(value);
    el.__vueDirectiveTitleOption__ = data;
    el.addEventListener("mousemove", moveFn);
    el.addEventListener("mouseout", leaveFn);
    el.addEventListener("mousedown", downFn);
  },
  update: function (el, { value }, vnode) {
    const currentOption = _.filter(
      vnode.data.directives,
      (item) => item.name === "title"
    )[0];
    if (
      JSON.stringify(currentOption.oldValue) !==
      JSON.stringify(currentOption.value)
    ) {
      el.removeEventListener("mousemove", moveFn);
      const data = handleDataFormatter(value);
      el.__vueDirectiveTitleOption__ = data;
      el.addEventListener("mousemove", moveFn);
    }
  },
  unbind: function (el) {
    el.__vueDirectiveTitleOption__ = null;
    el.removeEventListener("mousemove", moveFn);
    el.removeEventListener("mouseout", leaveFn);
    el.removeEventListener("mousedown", downFn);
  },
  install(Vue) {
    Vue.directive("title", {
      bind: this.bind,
      unbind: this.unbind,
      update: this.update,
    });
  },
};
